import { useNavigate } from 'react-router-dom';
import BannerImage from '../../components/bannerImage/bannerImage.js';
import Header from '../../components/header/header.js';
import './settings.css';
import React from 'react';

const Settings = () => {

    const navigate = useNavigate();

    return (
       <div className='settings-page-wrapper'>
       <Header />
       <BannerImage text='Settings'></BannerImage>
        <div className="settings-page">
            
            <h3>Memory Management</h3>
            <button className="clear-local-storage-btn" onClick={() => {
                localStorage.clear();
                console.log('Local storage cleared');
                navigate('/assessment/policy'); // Reload the page to reflect changes
            }}>Clear Local Storage</button><p>This will delete all data stored in LocalStorage, such as answer responses, and user data.</p>
            </div>
       </div>
    );
};

export default Settings;